<template>
  <div class="service-tabs">
    <div class="service-tabs__tabs">
      <div
        class="service-tabs__tabs__item"
        :class="{ active: tab1 }"
        @click="convertActive(1)"
      >
        Rules
      </div>
      <div
        class="service-tabs__tabs__item"
        :class="{ active: tab2 }"
        @click="convertActive(2)"
      >
        Services
      </div>
    </div>
    <div v-if="tab1" class="row">
      <div class="col-sm-3 col-lg-3">
        <div>
          <aside class="filter">
            <section>
              <a href="javascriptvoid:(0)" class="gold-link"> Back ></a>
              <h4 class="title">sector</h4>
              <ul class="main-menu">
                <li>
                  <div class="checkbox-parent">
                    <label class="custom-checkbox">
                      <input type="checkbox" />
                      <span class="custom-checkbox__img">
                        <img src="../../../Assets/Images/checked-icon.png" />
                      </span>
                    </label>
                    <span class="toggle-second-menu"
                      >item name
                      <a
                        data-toggle="collapse"
                        href="#a"
                        role="button"
                        aria-controls="a"
                      >
                        <i class="clickable-btn icon-arrow-down"> </i>
                      </a>
                    </span>
                  </div>
                  <ul class="second-level multi-collapse show" id="a">
                    <li>
                      <label class="custom-checkbox">
                        <input type="checkbox" />
                        <span class="custom-checkbox__img">
                          <img src="../../../Assets/Images/checked-icon.png" />
                        </span>
                        <span> item</span>
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>

              <!-- second section -->

              <h4 class="title">sector</h4>
              <ul class="main-menu">
                <li>
                  <div class="checkbox-parent">
                    <label class="custom-checkbox">
                      <input type="checkbox" />
                      <span class="custom-checkbox__img">
                        <img src="../../../Assets/Images/checked-icon.png" />
                      </span>
                    </label>
                    <span class="toggle-second-menu"
                      >item
                      <a
                        data-toggle="collapse"
                        href="javascript:void(0)"
                        role="button"
                      >
                        <i class="clickable-btn icon-arrow-down"> </i>
                      </a>
                    </span>
                  </div>
                  <ul class="second-level multi-collapse show" id="a">
                    <li>
                      <label class="custom-checkbox">
                        <input type="checkbox" />
                        <span class="custom-checkbox__img">
                          <img src="../../../Assets/Images/checked-icon.png" />
                        </span>
                        <span> item</span>
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>

              <div class="btns-wrapper-filter">
                <button class="custom-btn">
                  Apply
                </button>
                <button class="custom-btn">Reset</button>
              </div>
            </section>
          </aside>
        </div>
      </div>
      <div class="col-sm-9 col-lg-9">
        <div class="accordion-wrapper">
          <div class="accordion" id="accordionExample">
            <div class="card rules-card">
              <a class="card-body card-title">
                item
              </a>

              <div
                id="1"
                class="collapse show"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <div class="data">
                    <div class="data__details">
                      <div class="data__details__title">
                        22-4-2020
                      </div>
                      <div class="data__details__description">
                        <a href="javascript:void(0)"> Download </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tab2" class="row">
      Victor
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tab1: true,
      tab2: false,
    };
  },

  methods: {
    convertActive(item) {
      if (item == 1) {
        this.tab1 = true;
        this.tab2 = false;
      } else {
        this.tab1 = false;
        this.tab2 = true;
      }
    },
  },
};
</script>
